import { useMemo } from 'react';
import { QueryResult, useQuery } from 'react-query';
import { EmployeeRange, RefDataEmployeeRangeApi } from 'eve-account-client';
import { useConfiguration } from './BaseApi';

const useRefDataEmployeeRangeApi = (): RefDataEmployeeRangeApi => {
  const configuration = useConfiguration();
  const api = useMemo(() => new RefDataEmployeeRangeApi(configuration), [configuration]);
  return api;
};

const getEmployeeRanges = (api: RefDataEmployeeRangeApi): Promise<EmployeeRange[]> => {
  const request = api.getEmployeeRanges({});
  return request;
};

export const useEmployeeRangesQuery = (): QueryResult<EmployeeRange[], Error | Response> => {
  const api = useRefDataEmployeeRangeApi();

  return useQuery<EmployeeRange[], Error | Response>(['employeeRanges'], () => getEmployeeRanges(api));
};
